import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupVendorInvoice } from "src/components/Shared/NewForms/NFLookupVendorInvoice";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { useTranslation } from "react-i18next";

export const ImportsDetailImportTax = () => {
    const { t } = useTranslation();

    return (
        <>
            <NFormTable fieldArray={"importTax"}>
                <NFLookupProduct fieldName={"productId"} title={t("Product")} />
                <NFLookupVendorInvoice
                    fieldName={"vendorInvoice"}
                    title={t("VendorInvoice")}
                />
                <NFIntInput
                    fieldName={"customCost"}
                    title={t("CustomCost")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"importRate"}
                    title={t("ImportRate")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"importAmount"}
                    title={t("ImportAmount")}
                    width={100}
                />
                <NFIntInput
                    fieldName={"importAccountId"}
                    title={t("ImportAccount")}
                    width={100}
                />
            </NFormTable>
        </>
    );
};
